"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("./Input.styles"));

var _excluded = ["className", "inputMode", "inputProps", "intent"],
    _excluded2 = ["outline"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Input = /*#__PURE__*/(0, _react.forwardRef)(function Input(props, ref) {
  var className = props.className,
      inputMode = props.inputMode,
      inputProps = props.inputProps,
      intent = props.intent,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var error = intent === 'error';
  var color = intent === 'warning' ? 'secondary' : 'primary';

  var _useInputStyles = (0, _Input.default)(),
      outlineClass = _useInputStyles.outline,
      classes = (0, _objectWithoutProperties2.default)(_useInputStyles, _excluded2);

  return /*#__PURE__*/_react.default.createElement(_InputBase2.default, Object.assign({}, rest, {
    className: (0, _classnames.default)('pds-input', className, {
      'Mui-warning': intent === 'warning'
    }),
    classes: classes,
    color: color,
    error: error,
    inputProps: _objectSpread({
      inputMode: inputMode
    }, inputProps),
    ref: ref,
    renderSuffix: function renderSuffix() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('pds-input__outline', outlineClass)
      });
    }
  }));
});
Input.defaultProps = {
  inputProps: {}
};
Input.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: _propTypes.bool,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.string,

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: _propTypes.any,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.node,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: _propTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.string,

  /**
   * HTML [inputmode](https://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute).
   *
   * This is useful for mobile devices in order to tell the browser which type of keyboard it should show.
   */
  inputMode: (0, _propTypes.oneOf)(['none', 'text', 'tel', 'url', 'email', 'numeric', 'decimal', 'search']),

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _propTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.object]),

  /**
   * If it should have the `error`, `warning` or default styles.
   */
  intent: (0, _propTypes.oneOf)([undefined, 'error', 'warning']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.string,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: _propTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: _propTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: _propTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _propTypes.any
};
var _default = Input;
exports.default = _default;
